import {
  LayoutDashboard, Users, CheckSquare, GitBranch, FileText,
  DollarSign, Handshake, Mail, ShoppingBag, Inbox, LogOut, Settings
} from 'lucide-react';

const navItems = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "leads", label: "Leads", icon: Inbox },
  { id: "contacts", label: "Contacts", icon: Users },
  { id: "tasks", label: "Tasks", icon: CheckSquare },
  { id: "pipeline", label: "Pipeline", icon: GitBranch },
  { id: "invoices", label: "Invoices", icon: FileText },
  { id: "financials", label: "Financials", icon: DollarSign },
  { id: "vendors", label: "Vendors", icon: Handshake },
  { id: "store", label: "Store", icon: ShoppingBag },
  { id: "emails", label: "Emails", icon: Mail },
  { id: "settings", label: "Settings", icon: Settings },
];

export const Sidebar = ({ activeNav, setActiveNav, admin, onLogout }) => {
  return (
    <div className="fixed left-0 top-0 h-full w-64 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-white shadow-2xl z-50">
      <div className="p-6 border-b border-slate-700/50">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-royal-blue-500 to-royal-blue-700 flex items-center justify-center shadow-lg shadow-royal-blue-500/30">
            <span className="text-white font-bold text-lg">O</span>
          </div>
          <div>
            <h1 className="font-cabinet text-xl font-bold tracking-tight">OpLogMan</h1>
            <p className="text-xs text-slate-400 font-manrope">CRM Dashboard</p>
          </div>
        </div>
      </div>
      <nav className="p-4 space-y-1" data-testid="sidebar-nav">
        {navItems.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => setActiveNav(id)}
            data-testid={`nav-${id}`}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 ${
              activeNav === id
                ? "bg-royal-blue-600/20 text-royal-blue-400 shadow-lg shadow-royal-blue-500/10 border border-royal-blue-500/20"
                : "text-slate-400 hover:bg-slate-700/50 hover:text-white"
            }`}
          >
            <Icon size={18} />
            {label}
          </button>
        ))}
      </nav>
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-slate-700/50">
        {admin && (
          <div className="px-4 py-3 bg-slate-800/50 rounded-xl flex items-center justify-between" data-testid="sidebar-admin-info">
            <div className="min-w-0">
              <p className="text-sm text-white font-medium truncate">{admin.name}</p>
              <p className="text-xs text-slate-400 truncate">{admin.email}</p>
            </div>
            <button
              onClick={onLogout}
              data-testid="admin-logout-btn"
              className="ml-3 p-2 rounded-lg text-slate-400 hover:text-red-400 hover:bg-red-500/10 transition-colors flex-shrink-0"
              title="Sign out"
            >
              <LogOut size={16} />
            </button>
          </div>
        )}
        {!admin && (
          <div className="px-4 py-3 bg-slate-800/50 rounded-xl">
            <p className="text-xs text-slate-500 font-manrope">Opulence Logistics</p>
            <p className="text-xs text-slate-400">Management Corp.</p>
          </div>
        )}
      </div>
    </div>
  );
};
